var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpKnitwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H3c-.6 0-1-.4-1-1V6c0-1.1.8-2.3 1.9-2.6L8 2a4 4 0 0 0 8 0l4.1 1.4C21.2 3.7 22 4.9 22 6v12c0 .6-.4 1-1 1h-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8v13c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6 10 2 2 2-2 2 2 2-2 2 2 2-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m6 16 2 2 2-2 2 2 2-2 2 2 2-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpKnitwear);
export default __webpack_public_path__ + "static/media/icon-ip-knitwear.d43d4e05f74eb5cc8f9c50f41812e95d.svg";
export { ForwardRef as ReactComponent };